<template>
  <div class="home">
    <!--<section id="header-home" class="d-flex">
      <div class="container">
        <div class="row">
          <div class="col-md-6 ">
            <h2 class="mb-3">Tenha até 70% de economia em consultas e exames;</h2>
            <p>Economize até 70% em consultas e exames e muito mais;</p>
            <p>Cartão familiar válido para titular e mais três dependentes familiares;</p>
            <p>Não tem carência,limite de idade e utilização;</p>
            <p>Garantia de menor preço;</p>
            <p>Orçamento de consultas e exames;</p>
            <p>Histórico de todos os atendimentos com banco de dados de prontuário médico e receituários;</p>
            <p>Cartão Achei descontos em cinema, loja, supermercados e muito mais;</p>
            <p>Agendamento online;</p>
            <p>Avalie seu atendimento médico;</p>
            <p>Pagamento no ato de atendimento ou via Plataforma em até 10 vezes.</p>
            <br>
            
          </div>
          <div class="col-md-5">
            <div class="brand-sinsaude">
                <img src="@/img/cards-valor.png" alt="Valor Plano">
            </div>
            
            <router-link tag="a" class="btn btn-light btn-lg" :to="{name: 'FormSinSaude'}">COMPRAR DR.ACHEI CARD</router-link>
          </div>
        </div>
      </div>
    </section>-->
    <sin-saude-planos></sin-saude-planos>
  </div>
</template>
<script>
import SinSaudePlanos from '@/components/shared/SinSaudePlanos'
export default {
  components: {
    SinSaudePlanos
  }
}
</script>





// WEBPACK FOOTER //
// src/components/pages/SinSaudeCard.vue